export const roleCreatePost = (data) => {
    return data.data;
}
export const roleCreatePatch = (data) => {
    return data.data;
}
export const role_list_get = (data) => {
    return data.data;
}
export const roleStatusUpdateApi = (data) => {
    return data.data;
}
export const roleDeleteApi = (data) => {
    return data.data;
}
export const getHotelBranchListGet = (data) => {
    return data.data;
}